<template>
  <ul>
    <li v-for="store in stores" :key="store.storeid">
      <bopis-store-details
        :model-value="selectedStore"
        :show-address-preview="showAddressPreview"
        :store
        @update:model-value="(value) => selectedStore = value"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { LocatorSearchItem } from '#types/brandify'

defineProps<{
  stores: LocatorSearchItem[]
  showAddressPreview?: boolean
}>()

const selectedStore = defineModel<LocatorSearchItem>()
</script>
